__webpack_require__.p = "/apistudioghibli/";